module.exports = __webpack_public_path__ + "static/media/uploadFile.4e1aced5.svg";